import React, { useRef, useState, useEffect } from 'react';
import ReactDatePicker, {

  registerLocale,
} from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import { parseISO } from 'date-fns';
import { ptBR as pt } from 'date-fns/locale';
import { Container } from './styles';
import { Error } from '../styles';
import { startOfDay } from 'date-fns';
import { useForm } from 'src/components/UIComponents/Form/provider/formProvider';

registerLocale('pt', pt);


const DatePicker: React.FC<any> = ({ name, placeholder, setCallback = () => { }, ...rest }) => {
  const datepickerRef = useRef(null);



  const [date, setDate] = useState<Date | null>(null
  );




  const onStart = (currentValue) => {
    if (currentValue) {
      setDate(new Date(parseISO(currentValue)))
    }
  }

  const { registerField } = useForm();
  const setValueData = (content) => {

    setDate(content)
  }

  const getValue = () => {

    return date;
  }

  useEffect(() => {
    registerField(
      name,
      setValueData,
      getValue,
      onStart

    );
  }, [name, date]);



  return (
    <Container isFocused={false} isErrored={false} isFilled={false}>
      <span>{placeholder}</span>
      <ReactDatePicker
        locale="pt"
        dateFormat="P"
        ref={datepickerRef}
        selected={date}
        onChange={(v) => {

          if (v) { setDate(startOfDay(v)) }
          else { setDate(null) };

          setCallback(v ? startOfDay(v) : null)
        }}


        {...rest}
      />
    </Container>
  );
};
export default DatePicker;
